// Shared no-op for components that require callback props the caller doesn't need
// (e.g. guided-tour previews neutralizing student-page side-effect setters).
export const noop = () => {};
